import { Divider } from "@luce/ui";

import { formatPackageDate } from "../../lib";
import { formatSchedules, getBillingTypeLabel, getFrequencyLabel } from "../lib";
import { usePackageDetailContext } from "../package-detail-context";
import { PackageDetailRow } from "./package-detail-row";
import { PackageSection } from "./package-section";

export function PackageDetailInfo() {
  const { packageDetail } = usePackageDetailContext();

  return (
    <>
      <Divider />
      <PackageSection icon="ClipboardText" title="Details">
        <PackageDetailRow label="Billing Type" value={getBillingTypeLabel(packageDetail)} />
        <PackageDetailRow
          label="Frequency"
          value={getFrequencyLabel(packageDetail.repeatEvery, packageDetail.repeatEveryTimes)}
        />
        <PackageDetailRow
          label="Start Date"
          value={formatPackageDate(packageDetail.startDate) ?? "Not Set"}
        />
        <PackageDetailRow
          label="End Date"
          value={formatPackageDate(packageDetail.endDate) ?? "Not Set"}
        />
        <PackageDetailRow
          label="Scheduled Timing"
          value={formatSchedules(packageDetail.tasks)}
          divider={false}
        />
      </PackageSection>
    </>
  );
}
